const COMMON_FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "ymail.com",
  "rocketmail.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "msn.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "proton.me",
  "protonmail.com",
  "pm.me",
  "gmx.com",
  "gmx.net",
  "mail.com",
  "yandex.com",
  "yandex.ru",
  "qq.com",
  "163.com",
  "126.com",
  "rediffmail.com",
  "inbox.com",
  "tutanota.com",
  "tuta.com",
]);

function emailDomain(email: string): string {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf("@");
  if (at <= 0 || at === trimmed.length - 1) return "";
  return trimmed.slice(at + 1);
}

function isConsumerProviderDomain(domain: string): boolean {
  if (COMMON_FREE_EMAIL_DOMAINS.has(domain)) return true;
  return (
    domain.startsWith("yahoo.") ||
    domain.endsWith(".yahoo.com") ||
    domain.startsWith("hotmail.") ||
    domain.startsWith("outlook.") ||
    domain.startsWith("live.")
  );
}

/** True for public inboxes such as gmail.com or yahoo.com. Business domains return false. */
export function isCommonFreeEmail(email: string): boolean {
  const domain = emailDomain(email);
  if (!domain) return false;
  return isConsumerProviderDomain(domain);
}
